import { render, staticRenderFns } from "./RelatorioLogOrganograma.vue?vue&type=template&id=4e78053e"
import script from "./RelatorioLogOrganograma.vue?vue&type=script&lang=js"
export * from "./RelatorioLogOrganograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports